import 'survey-core/survey.i18n.js';
import 'survey-creator-core/survey-creator-core.i18n.js';

import React, { useMemo, useEffect, useState } from 'react';
import { IUser } from '../../models';
import PaneHeadline from '../shared/paneHeadline';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { SurveyCreatorComponent, SurveyCreator } from 'survey-creator-react';

import '../../styles/survey-core.css';
import '../../styles/survey-creator-core.css';

import './surveyCreator.scss';
import { AsyncAction } from '../../utils';
import { ISchema, ISchemaType } from '../../models/Schema.model';
import Select from 'react-select';
import { Spinner2 } from '../shared/spinner2';

import 'survey-core/i18n/german';
import 'survey-core/i18n/french';
import 'survey-core/i18n/dutch';
import 'survey-core/i18n/english';
import 'survey-core/i18n/croatian';
import 'survey-core/i18n/norwegian';
import 'survey-core/i18n/swedish';

import 'survey-creator-core/i18n/german';
import 'survey-creator-core/i18n/french';
import 'survey-creator-core/i18n/dutch';
import 'survey-creator-core/i18n/english';
import 'survey-creator-core/i18n/croatian';
import 'survey-creator-core/i18n/norwegian';
import 'survey-creator-core/i18n/swedish';
import {
  langCode,
  locale,
} from '../../common/localization/localizationService';

export interface ISurveyCreatorProps {
  impersonatedUser: any;
  authentication: IUser;
  isLoading: boolean;
  schemaTypes: Array<ISchemaType>;
  selectedSurvey: ISchema;
  selectedType: ISchemaType;
  saveSurvey: (survey: ISchema) => AsyncAction;
  loadSchemaTypes: (ignorecache?: boolean) => AsyncAction;
  getSurvey: (id: number) => AsyncAction;
  setSelectedSchemaType: (selectedSchema: ISchemaType) => void;
}

export default function SurveyCreatorPage(
  props: ISurveyCreatorProps
): JSX.Element {
  const [selectedType, setSelectedType] = useState(props.selectedType);
  const [schemaTypeOptions, setSchemaTypeOptions] = useState([]);
  useEffect(() => {
    props.loadSchemaTypes();
  }, []);

  useEffect(() => {
    getSchemaTypesDataSource();
  }, [props.schemaTypes]);

  const creator = useMemo(() => {
    const c = new SurveyCreator({
      showLogicTab: true,
    });

    c.locale = langCode;
    return c;
  }, []);

  useEffect(() => {
    if (props.selectedSurvey?.surveySchema) {
      try {
        const parsed =
          typeof props.selectedSurvey.surveySchema === 'string'
            ? JSON.parse(props.selectedSurvey.surveySchema)
            : props.selectedSurvey.surveySchema;

        creator.JSON = parsed;
      } catch (err) {
        console.error('Failed to parse schema JSON', err);
      }
    } else {
      const emptySchema = {};
      creator.JSON = emptySchema;
    }
  }, [props.selectedSurvey, creator]);

  const upsertSurvey = () => {
    props.saveSurvey({
      surveySchema: JSON.stringify(creator.JSON),
      typeId: props.selectedSurvey.typeId,
      surveyId: props.selectedSurvey.surveyId,
    } as ISchema);
  };

  const handleSchemaTypeChange = (data: ISchemaType): void => {
    props.getSurvey(data.surveyTypeId);
    setSelectedType(data);
    props.setSelectedSchemaType(data);
  };

  const getSchemaTypesDataSource = (): void => {
    const routesDataSource = props.schemaTypes.map((schemaType) => ({
      ...schemaType,
      value: schemaType.key,
      label: schemaType.name,
    }));

    setSchemaTypeOptions(routesDataSource);

    if (routesDataSource && routesDataSource.length > 0) {
      const selected = props.selectedType
        ? routesDataSource.find(
            (r) => r.surveyTypeId === props.selectedType.surveyTypeId
          )
        : undefined;

      setSelectedType(selected ?? routesDataSource[0]);
    }
  };

  return (
    <div className="survey-creator">
      <Spinner2 show={props.isLoading} />
      <PaneHeadline
        titleText={locale.surveyCreator._schemas}
        titleIcon={faCheckDouble}
      />
      <div className="survey-actions-wrapper">
        <Select
          options={schemaTypeOptions}
          value={selectedType}
          onChange={handleSchemaTypeChange}
          className="schema-type-selector"
        />
        <button
          className="btn btn-outline-dark mr-2 save-survey-button"
          onClick={upsertSurvey}
        >
          {locale.surveyCreator._saveSchema}
        </button>
      </div>
      <SurveyCreatorComponent creator={creator} />
    </div>
  );
}
